import { theme as baseTheme, createTheme, type PartialTheme } from '@shared/components';

import sidebarTheme from './sidebar/sidebar';

const examCenterTheme: PartialTheme = {
  components: {
    ...sidebarTheme,
  },
};

export const theme = createTheme(baseTheme, examCenterTheme);
